import FormMultiSelect from './FormMultiSelect';

export default FormMultiSelect;
